export const Props = () => ({
  //ID сигнала
  signalId: {
    type: Number,
    required: true,
  }
});